import { Component, input, InputSignal, ViewChild } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatDatepicker, MatDatepickerInput, MatDatepickerToggle } from '@angular/material/datepicker';
import { MAT_DATE_FORMATS, MatDateFormats } from '@angular/material/core';
import moment from 'moment';
import { MatFormField, MatLabel, MatInput, MatSuffix } from '@angular/material/input';

export const MONTH_PICKER_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
    selector: 'app-monthpicker',
    templateUrl: './monthpicker.component.html',
    providers: [
        { provide: MAT_DATE_FORMATS, useValue: MONTH_PICKER_FORMATS },
    ],
    imports: [
        MatFormField,
        MatLabel,
        MatInput,
        MatDatepickerInput,
        ReactiveFormsModule,
        MatDatepickerToggle,
        MatSuffix,
        MatDatepicker,
    ],
})
export class MonthPickerComponent {
  label = input<string>('');
  placeholder = input<string>('');
  formControlRef = input.required<FormControl>();
  required = input<boolean>(false);
  min = input<Date | undefined>();
  max = input<Date | undefined>();

  @ViewChild(MatDatepicker) datepicker!: MatDatepicker<any>;

  onMonthSelected(normalizedMonthAndYear: moment.Moment, datepicker: MatDatepicker<any>) {
    const selectedDate = normalizedMonthAndYear.clone().startOf('month');
    this.formControlRef().setValue(selectedDate.toDate());
    datepicker.close();
  }
}
